/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { array as codecArray } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { CourseSection } from './CourseSection';
import { User } from './User';
const ExtendedCourseSectionParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    [
        'members',
        /* #__PURE__ */ parsers.maybeNull(/* #__PURE__ */ codecArray(User)),
    ],
]), CourseSection);
export class ExtendedCourseSection extends CourseSection {
    static decode(input) {
        return ExtendedCourseSectionParser.decode(input).map(res => new ExtendedCourseSection(res));
    }
    static unsafeDecode(input) {
        return ExtendedCourseSection.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ExtendedCourseSectionParser.encode(data);
    }
    static schema() {
        return ExtendedCourseSectionParser.schema();
    }
}
